import { createSlice } from "@reduxjs/toolkit";
import { LOGIN } from "../types/types";

// Restore persisted login state
const persistedLoginState = JSON.parse(
  localStorage.getItem("loginState") ?? "null"
);

const persistedToken = localStorage.getItem("authToken");

const loginInitialState = {
  login: {
    data: persistedLoginState || {},
    isLoading: false,
    errors: "",
    userName: persistedLoginState?.email ?? "",
    isAuthenticated: !!persistedToken, // ✅ restore auth correctly
  },
};

export const loginSlice = createSlice({
  name: LOGIN,
  initialState: loginInitialState,
  reducers: {
    // 🔹 Start Login
    getLoginAction: (state) => {
      state.login.isLoading = true;
      state.login.errors = "";
    },

    // 🔹 Login Success
    getLoginSuccessAction: (state, { payload: data }) => {
      state.login.isLoading = false;
      state.login.data = data;
      state.login.userName = data?.email ?? "";
      state.login.isAuthenticated = true;

      console.log("Login Success Data:", data);

      localStorage.setItem("authToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("loginState", JSON.stringify(data));
    },

    // 🔹 Login Error
    getLoginErrorAction: (state, { payload: error }) => {
      state.login.isLoading = false;
      state.login.errors = error;
      state.login.isAuthenticated = false;
    },

    // 🔹 Set Username manually (optional)
    getLoginUserName: (state, action) => {
      state.login.userName = action.payload;
    },

    // 🔹 Logout
    logout: (state) => {
      state.login.isAuthenticated = false;
      state.login.userName = "";
      state.login.data = {};

      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("loginState");
    },
  },
});

export const {
  getLoginAction,
  getLoginSuccessAction,
  getLoginErrorAction,
  getLoginUserName,
  logout,
} = loginSlice.actions;

export default loginSlice.reducer;
